import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { images, offerItems, pricing } from '../data/landing';
export function OfferSection() {
  return <section id="oferta" className="w-full bg-cream py-20 lg:py-24" data-id="element-99" data-mp="8mwum1b1ar4g">
      <div className="mx-auto max-w-content px-6" data-id="element-100" data-mp="8llqu1hl9jdc">
        <h2 className="mx-auto max-w-2xl text-center font-display text-3xl font-bold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-101" data-mp="df6r606nmpfp">
          Todo lo que recibís al sumarte hoy
        </h2>

        <div className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-[1.15fr_0.85fr] lg:items-start" data-id="element-102" data-mp="mdsa3wg1g6h0">
          <div className="rounded-3xl bg-white p-6 shadow-sm sm:p-9" data-id="element-103" data-mp="rey3zxlfpzs4">
            <ul className="divide-y divide-cream-deep" data-id="element-104" data-mp="wcraysukaxtg">
              {offerItems.map(item => <li key={item.label} className="flex items-baseline justify-between gap-6 py-4 first:pt-0" data-id="element-105" data-mp="2t5t1ctvai70y">
                  <div data-id="element-106" data-mp="2y6gqtb3veft2">
                    <p className={`font-display font-bold text-ink ${item.highlight ? 'text-lg' : 'text-base'}`} data-id="element-107" data-mp="12niedon92hv2">
                      {item.label}
                    </p>
                    <p className="mt-0.5 text-sm text-ink-muted" data-id="element-108" data-mp="sxyqg4kojxtc">
                      {item.detail}
                    </p>
                  </div>
                  <p className="shrink-0 text-base font-semibold text-ink-muted" data-id="element-109" data-mp="1lmw8q7ow5um3">
                    {item.price}
                  </p>
                </li>)}
            </ul>

            <div className="mt-6 flex items-baseline justify-between gap-6 border-t-2 border-ink pt-5" data-id="element-110" data-mp="1clg0o6lju4l1">
              <p className="font-display text-sm font-bold uppercase tracking-[0.14em] text-ink" data-id="element-111" data-mp="17n4p9rflvm0p">
                Valor total
              </p>
              <p className="text-xl font-bold text-ink-muted line-through decoration-sunset decoration-2" data-id="element-112" data-mp="1842ab8k6e69">
                {pricing.totalValue}
              </p>
            </div>
          </div>

          <div className="rounded-3xl bg-white p-6 text-center shadow-xl shadow-ink/5 sm:p-9" data-id="element-113" data-mp="3tuizwwtz9moi">
            <img src={images.pack} alt="Megapack completo: 6 tomos digitales más los 5 bonos" className="mx-auto w-40 rounded-2xl sm:w-52" width={512} height={512} data-id="element-114" data-mp="2mdfhqtch1v7" />
            <p className="mt-6 text-xs font-semibold uppercase tracking-[0.16em] text-nature-dark" data-id="element-115" data-mp="3b3hze4d7lj2u">
              Precio especial hoy
            </p>
            <p className="mt-2 font-display text-5xl font-extrabold tracking-tight text-ink" data-id="element-116" data-mp="3fv014un23nov">
              {pricing.today}
            </p>
            <p className="mt-2 text-sm text-ink-muted" data-id="element-117" data-mp="364evwocvnkwz">
              Pago único · Acceso de por vida
            </p>
            <div className="mt-7" data-id="element-118" data-mp="2s4vx4m5yhlxc">
              <CtaButton size="lg" className="w-full" location="oferta" data-id="element-119" data-mp="2s5ypkyixfwfd">
                Comprar Megapack ahora
              </CtaButton>
            </div>
            <p className="mt-5 inline-flex items-center gap-2 text-sm text-ink-soft" data-id="element-120" data-mp="2dhox3bi0e8d8">
              <ShieldCheckIcon className="h-4 w-4 text-nature-dark" aria-hidden="true" data-id="element-121" data-mp="28iu4xiy5j7gg" />
              Garantía de satisfacción de 7 días
            </p>
          </div>
        </div>
      </div>
    </section>;
}